
<section class="section">
	<div class="section__title">Recursos</div>

	<div class="hs">
		<!-- Recursos Institucionales -->
		<div class="card institucionales" routerLink="/recursos/institucionales" gtagEvent="ver-recursos-institucionales" gtagCategory="documentos">
			<div class="content">
				<div class="text">
					<div class="title">Institucionales</div>
					<div>Logos, plantillas, imágenes y otros recursos del Hospital Italiano, Universidad y Plan de Salud</div>
				</div>
			</div>
		</div>
		<!-- Información Médica -->
		<div class="card info-medica" routerLink="/recursos/informacion-medica" gtagEvent="ver-informacion-medica" gtagCategory="documentos">
			<div class="content">
				<div class="text">
					<div class="title">Información Médica</div>
					<div>Consentimientos, manuales, reglamentos y más.</div>
				</div>
			</div>
		</div>
	</div>
</section>